import React from 'react';
import FeaturedWorks from '../components/FeaturedWorks.jsx';
import Availability from '../components/Availability.jsx';

export default function Fullstack() {
  return (
    <>
      <h2 className="page-header">Fullstack</h2>
      <section>
        <p>Web and mobile projects: products, dashboards, APIs, and platform work.</p>
        <ul className="styled-list">
          <li>Frontend: React, Vite, TypeScript, accessibility, performance</li>
          <li>Backend: Node/Express, REST, auth, queues, testing</li>
          <li>Infra: Railway/Render/Vercel, Docker, CI, observability</li>
        </ul>
      </section>

      <FeaturedWorks category="fullstack" title="Featured Fullstack Works" layout="rows" />

      <Availability />
    </>
  );
}


